import { CollectionElementDataType } from '@/components/sections/builder/elements/body/collection-list/type';
import CollectionSetting from '@/components/sections/builder/settings/collection-setting';
import { ElementProps } from '@/components/sections/builder/types';

import { useBuilderStore } from '@/stores/builder';
import { Tags } from 'lucide-react';
import { shallow } from 'zustand/shallow';

const defaultData: CollectionElementDataType = {
  name: 'Collection',
  collection: {
    collection_name: 'Collection 1',
    collection_id: '1',
    slug: 'collection-1',
    img_url: 'https://via.placeholder.com/300',
    description:
      'Lorem ipsum dolor sit amet consectetur adipiscing elit, magnis augue lectus eros dignissim ligula, laoreet elementum luctus eleifend quisque morbi.Collection description',
  },
};

export const ElementContent = () => {
  return <></>;
};

export const ElementPreviewIcon = Tags;

export function ElementSetting({ element }: ElementProps) {
  const builder = useBuilderStore(
    (state) => ({
      setChildData: state.setChildData,
    }),
    shallow
  );

  const data = (element.data || defaultData) as CollectionElementDataType;

  return (
    <div>
      <CollectionSetting
        value={data.collection}
        onChange={(val) =>
          builder.setChildData(element.parentId as string, element.id, {
            collection: val,
          })
        }
      />
    </div>
  );
}

const Collection = {
  type: 'collection',
  group: 'collection_list',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  Icon: ElementPreviewIcon,
  childs: [],
};

export default Collection;
